// @flow

"use strict";

import React from "react";
import ReactDOM from "react-dom";

import Sidenote from "./Sidenote";

/**
 * Have to do this in a kinda gross way because Ghost/Handlebars doesn't ID tag the
 * footnotes element.
 * Structure on the page:
 * hr class="footnotes-sep"
 * section class="footnotes" > ol class="footnotes-list" > li class="footnote-item"
 */
const getFootnoteElements = () => {
  let restructuredEls = [];

  const wrapperDivCollection = document.getElementsByClassName('footnotes');
  for (const wrapperDiv of wrapperDivCollection) {
    const listElCollection = wrapperDiv.getElementsByClassName('footnotes-list');
    for (const listEl of listElCollection) {
      const itemsCollection = listEl.getElementsByClassName('footnote-item');
      if (itemsCollection.length > 0) {
        restructuredEls.push({listNo: restructuredEls.length, wrapperDiv, listEl, footnotes: [...itemsCollection]});
      }
    }
  }
  return restructuredEls;
}

// <li class="footnote-item" id="fn11">
//   <p>
//     [text of footnote]
//     <a class="footnote-backref" href="#fnref10">[back]</a>
const extractFromFootnoteEl = (footnoteEl: Element, prefixForId: ?string) => {
  if (footnoteEl.getElementsByClassName('footnote-backref').length === 0) {
    // Couldn't find backref link, bail
    return null;
  }
  const backrefEl = footnoteEl.getElementsByClassName('footnote-backref')[0];
  const backrefSlug = backrefEl.getAttribute('href');
  if (!backrefSlug || backrefSlug.charAt(0) !== '#') {
    // This href is weird (should start with # to point to parent link ID), bail
    return null;
  }

  const parentId = backrefSlug.substr(1);
  const prefixedParentId = (prefixForId ?? '') + parentId;

  const parentLink = document.getElementById(parentId);
  if (parentLink) {
    parentLink.id = prefixedParentId;
  }

  backrefEl.parentElement?.removeChild(backrefEl);

  const footnoteText = footnoteEl.innerHTML;
  const footnoteId = (prefixForId ?? '') + footnoteEl.id;
  footnoteEl.id = footnoteId;

  return {footnoteId, footnoteText, parentId: prefixedParentId};
}

// sup class="footnote-ref" > a href="#footnoteId" id="parentId"
const swapOutParentRef = (parentId: string) => {
  const footnoteLink = document.getElementById(parentId);
  const footnoteRef = footnoteLink?.parentElement;
  const refParentContainer = footnoteRef?.parentElement;
  if (!footnoteLink || !footnoteRef || !refParentContainer) {
    return null;
  }
  const newEl = document.createElement('span');
  // newEl.className = 'rpc3-sidenote-wrapper';
  refParentContainer.insertBefore(newEl, footnoteRef);
  footnoteRef.removeChild(footnoteLink);
  refParentContainer.removeChild(footnoteRef);
  return newEl;
}

const renderSidenotesForBlock = (footnotesBlock, blockNumber: ?number) => {
  blockNumber = blockNumber ?? 0;
  const {wrapperDiv, listEl, footnotes} = footnotesBlock;

  for (const footnoteEl of footnotes) {
    const footnoteData = extractFromFootnoteEl(footnoteEl, '' + blockNumber);
    if (!footnoteData) {
      continue;
    }
    const {footnoteId, footnoteText, parentId} = footnoteData;
    const renderWrapper = swapOutParentRef(parentId);
    if (!renderWrapper) {
      continue;
    }
    listEl.removeChild(footnoteEl);
    ReactDOM.render(
      <React.StrictMode>
        <Sidenote footnoteId={footnoteId} footnoteContent={footnoteText} />
      </React.StrictMode>,
      renderWrapper
    );
    const sidenoteEls = [...renderWrapper.children];
    for (const sidenoteEl of sidenoteEls) {
      renderWrapper.parentElement?.insertBefore(sidenoteEl, renderWrapper);
    }
    renderWrapper.parentElement?.removeChild(renderWrapper);
  }

  wrapperDiv.parentElement?.removeChild(wrapperDiv);
}

const renderSidenotes = () => {
  const footnoteElements = getFootnoteElements();

  footnoteElements.forEach((elementsBlock, index) => renderSidenotesForBlock(elementsBlock, index));
};

export default renderSidenotes;
